import IntercomChat, {
    intercomName,
    useOpenIntercomChat,
} from "@common/components/chat/IntercomChat"
import { hasTutorSupportChat } from "@common/components/chat/supportChatAccess"
import React from "react"

/**
 * Le pont legacy de la coquille de l'espace tuteur : il monte `TutorNavigator` (ports) et lui
 * descend ce que les ports ne peuvent pas importer de `common/` — les onglets que l'ancienne
 * coquille calcule (`tutorTabScreens.js`, filtrés par les droits) et l'ouverture du chat du support.
 *
 * Le chat du support du tuteur (`IntercomChat` identifié) reste monté ici, comme sous l'ancienne
 * coquille ; sa bulle flottante (`HelpFAB`) devient le bouton d'aide de l'en-tête du design system.
 */
const TutorShellBridge = ({ user, tabScreens }) => {
    const openSupportChat = useOpenIntercomChat()
    const supportChat = hasTutorSupportChat(user)

    // `require` paresseux : éteint, rien du code de l'espace tuteur n'est évalué au démarrage.
    /* global require */
    const {
        TutorNavigator,
    } = require("../../ports/primary/ui/screens/tutor/TutorNavigator")

    const tabs = tabScreens.map((screen) => ({
        name: screen.name,
        component: screen.component,
        badge: screen.options?.tabBarBadge ?? null,
    }))

    return (
        <>
            <TutorNavigator
                tabs={tabs}
                onContactSupport={supportChat ? openSupportChat : undefined}
            />
            {supportChat && (
                <IntercomChat
                    identified
                    userId={user.id}
                    email={user.email}
                    name={intercomName(user)}
                />
            )}
        </>
    )
}

export default TutorShellBridge
